import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ReactComponent as Building } from '../../assets/images/svg/building.svg';
import themeColors from '../../assets/styles/themeColors';

const BuildingIconStyled = styled(Building)`
  width: ${({ w }) => w};
  height: ${({ h }) => h};
  stroke: ${({ color }) => color || themeColors.colorTextSecondary};
`;

const BuildingIcon = (props) => <BuildingIconStyled {...props} />;

BuildingIcon.propTypes = {
  w: PropTypes.string,
  h: PropTypes.string,
  color: PropTypes.string,
};

BuildingIcon.defaultProps = {
  w: '25px',
  h: '25px',
};

export default BuildingIcon;
